var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrapper d-none"},[_c('router-link',{staticClass:"text-decoration-none btn btn-outline-primary",attrs:{"to":"/"}},[_vm._v(" ⬅️ MC ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }